module.exports = __webpack_public_path__ + "img/32090b894ad34720946d02ff7459b356-1440.673d952e.jpg";